// extracted by mini-css-extract-plugin
export default {"container":"NotificationList_container__mP839"};